import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Self } from '@angular/core';
import { AbstractControl, ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import moment, { Moment } from 'moment';
import { Subscription } from 'rxjs';
import { TIME_SHORT_FORMAT } from '../../common/constants/date-config';
import { AutoUnsubscribe, markRequiredControlWithAsteriskSymbol } from '../../common';
import { DateModule } from '../../date.module';

type TimeType = Date | Moment | string;
@Component({
  selector: 'ui-time-input',
  imports: [TranslateModule, DateModule],
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class TimeInputComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() appearance: MatFormFieldAppearance;
  @Input() set min(min: TimeType) {
    this.minTime = moment(min, [TIME_SHORT_FORMAT]);
  }
  @Input() set max(max: TimeType) {
    this.maxTime = moment(max, [TIME_SHORT_FORMAT]);
  }

  minTime: Moment;

  maxTime: Moment;

  timeValue: Moment;

  subscriptions: Subscription[] = [];
  isFieldRequired: (control: UntypedFormControl | AbstractControl) => string = markRequiredControlWithAsteriskSymbol;

  constructor(@Self() public ngControl: NgControl, private changeDetectorRef: ChangeDetectorRef) {
    ngControl.valueAccessor = this;
  }

  registerOnChange(fn: () => TimeType): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: TimeType): void {
    this.timeValue = moment(value, [TIME_SHORT_FORMAT]);

    this.changeDetectorRef.detectChanges();
  }

  onTimeValueChanged(event: { value: Moment }): void {
    const timeValue = event.value?.format(TIME_SHORT_FORMAT);
    this.timeValue = event.value;

    this.onChange(timeValue);
  }

  private onChange: (value: TimeType) => TimeType;

  private onTouched: () => void;
}
